module.exports = __webpack_public_path__ + "img/safe_03.586af080.png";